module.exports = "/packs/images/homepage/whatson/stand_up_to_cancer_desktop~bcdccb5804f5a0d1ca1e1161197bda91.jpg";